<template>
  <div class="grid-container full">
    <div class="grid-x page-contents-8">
      <div class="small-12 cell text-left">
        <h1>Publications</h1>
      </div>
    </div>

    <div class="grid-x" id="showForNonIE">
      <div class="small-12 cell text-left carousel-cont">

        <div class='carousel-view'>
          <transition-group
            name='carousel'
            class='carousel'
            tag="div">
            <div
              v-for="slide in slides"
              class='slide'
              :key="slide.id">
              <img
                class='slide-image'
                :tabindex="slide.tabindex"
                :src='slide.imgLink'
                :alt='slide.altText'
                @click="openResearchModal(slide.id)"
                @keypress="openResearchModal(slide.id)"
              />
            </div>
          </transition-group>
        </div>
        <img tabindex="40" class="prevArrow"
             src="@/assets/img/icons/left-white.png"
             @click="previous"
             @keypress="previous"
        />
        <img tabindex="41" class="nextArrow"
             src="@/assets/img/icons/right-white.png"
             @click="next"
             @keypress="next"
        />

      </div>
    </div>


    <div class="grid-x small-up-1 medium-up-3 large-up-4 page-contents-8" id="showForIE11" >

        <div
          v-for="slide in slides"
          class="cell research-cell"
          :key="slide.id">
          <img
            class="research-image"
            :tabindex="slide.tabindex"
            :src='slide.imgLink'
            @click="openResearchModal(slide.id)"
            @keypress="openResearchModal(slide.id)"
          />
        </div>
      </div>
    <rare-research-modal
      v-if="researchModalOpen"
      :researchPaperToShow="researchPaperToShow"
    @closeResearchModal="closeResearchModal"/>

  </div>
</template>

<script>

import researchCarouselModal from './researchCarouselModal';

export default {
  name: 'researchCarousel',
  components: {
    'rare-research-modal': researchCarouselModal,
  },
  data() {
    return {
      w: window.width,
      largeText: null,
      smallText: null,
      researchModalOpen: false,
      researchPaperToShow: null,
      oldYPos: 0,
      timeout: 2000,
      slides: [
        {
          // eslint-disable-next-line
          imgLink: require('@/assets/img/research/social-mobility-in-graduate-recruitment.png'),
          altText: 'Social mobility in graduate recruitment',
          id: 'mobility',
          tabindex: 59,
        },
        {
          // eslint-disable-next-line
          imgLink: require('@/assets/img/research/closing_the_ethnicity_stay_gap.png'),
          altText: 'Closing the ethnicity stay gap',
          id: 'staygap',
          tabindex: 60,
        },
        {
          // eslint-disable-next-line
          imgLink: require('@/assets/img/research/one-of-us-cover.png'),
          altText: 'The experience of Jews and Muslims in City Law',
          id: 'oneofus',
          tabindex: 61,
        },
        {
          // eslint-disable-next-line
          imgLink: require('@/assets/img/research/experience-of-british-bangladeshis-and-pakistanis-in-city-law.png'),
          altText: 'The experience of British Bangladeshis and Pakistanis in City Law',
          id: 'expcitylaw',
          tabindex: 61,
        },
        // FIRST
        {
          // eslint-disable-next-line
          imgLink: require('@/assets/img/research/high-achieving-black-students.png'),
          altText: 'High Achieving Black Students',
          id: 'highachievingblackstudents',
          tabindex: 50,
        },
        {
          // eslint-disable-next-line
          imgLink: require('@/assets/img/research/class-race-graduate-recruitment.png'),
          altText: 'Class, race and graduate recruitment',
          id: 'class',
          tabindex: 51,
        },
        {
          // eslint-disable-next-line
          imgLink: require('@/assets/img/research/five-years-on.png'),
          altText: 'Contextual recruitment, CRS - Five years on',
          id: 'five',
          tabindex: 52,
        },
        {
          // eslint-disable-next-line
          imgLink: require('@/assets/img/research/social-mobility-grad-recruitment.png'),
          altText: 'Social mobility in graduate recruitment',
          id: 'social',
          tabindex: 53,
        },
        {
          // eslint-disable-next-line
          imgLink: require('@/assets/img/research/unconscious-bias-grad-recruitment.png'),
          altText: 'Unconscious bias in graduate recruitment',
          id: 'bias',
          tabindex: 54,
        },
        {
          // eslint-disable-next-line
          imgLink: require('@/assets/img/research/contextual-recruitment-aus.png'),
          altText: 'Contextual recruitment in Australia',
          id: 'aus',
          tabindex: 55,
        },
        {
          // eslint-disable-next-line
          imgLink: require('@/assets/img/research/contextual-recruitment-aus-one-year-on.png'),
          altText: 'Contextual recruitment in Australia, one year on',
          id: 'ausYear',
          tabindex: 56,
        },
        {
          // eslint-disable-next-line
          imgLink: require('@/assets/img/research/level-playing-field.png'),
          altText: 'Contextual recruitment system (CRS), leveling the playing field',
          id: 'field',
          tabindex: 57,
        },
        {
          // eslint-disable-next-line
          imgLink: require('@/assets/img/research/measures-that-matter.png'),
          altText: 'Measures that matter',
          id: 'measures',
          tabindex: 58,
        },
      ],
    };
  },
  mounted() {
    this.startInterval();
  },
  beforeDestroy() {
    clearInterval(this.intervalResearch);
  },
  methods: {
    startInterval() {
      this.intervalResearch = setInterval(() => {
        this.next();
      }, this.timeout);
    },
    endInterval() {
      clearInterval(this.intervalResearch);
    },
    resetInterval() {
      clearInterval(this.intervalResearch);
      this.intervalResearch = setInterval(() => {
        this.next();
      }, this.timeout);
    },
    next() {
      this.largeText = this.slides[3].largeText;
      this.smallText = this.slides[3].smallText;
      const first = this.slides.shift();
      this.slides = this.slides.concat(first);
      this.resetInterval();
    },
    previous() {
      this.largeText = this.slides[1].largeText;
      this.smallText = this.slides[1].smallText;
      const last = this.slides.pop();
      this.slides = [last].concat(this.slides);
      this.resetInterval();
    },
    openResearchModal(researchId) {
      this.researchModalOpen = true;
      this.researchPaperToShow = researchId;
      this.oldYPos = window.pageYOffset;
      window.scrollTo(0, 0);
    },
    closeResearchModal() {
      this.researchModalOpen = false;
      this.researchPaperToShow = null;
      window.scrollTo(0, this.oldYPos);
    },
  },
};
</script>

<style lang="scss" scoped>

  @import "~@/css/global.scss";

  .carousel-cont {
    position: relative;
    margin-top: 48px;
  }

  .carousel-view {
    position: absolute;
    //border: 2px solid blue;
    height: 288px;
    display: flex;
    flex-direction: column;
    justify-content: center;
    align-items: center;
    overflow: hidden;
    margin-bottom: 30px;
  }

  .carousel {
    //border: 2px solid green;
    display: flex;
    justify-content: center;
    align-items: center;
    width: 100%;
    min-height: 288px;
    overflow: hidden;
  }

  .slide {
    //border: 2px solid red;
    transform: translateZ(0) scale(1.0, 1.0);
    display: flex;
    justify-content: center;
    align-items: center;
    transition: transform 0.5s ease-in-out;
    overflow: visible;
  }

  .slide:last-of-type, .slide:first-of-type {
    opacity: 0 !important;
  }

  .full {
    background-color: $dark-grey-background;
    padding-bottom:316px;
  }

  h1 {
    color: #ffffff;
    font-weight: bold;
    font-style: normal;
    font-stretch: normal;
    text-align: left;
  }

  p, a {
    color: #ffffff;
    font-weight: normal;
    font-style: normal;
    font-stretch: normal;
    text-align: left;
  }

  p strong {
    font-weight: bold;
    font-style: normal;
    font-stretch: normal;
    text-align: left;
  }

  .research-image {
    height: 100%;
    cursor: pointer;
  }

  .prevArrow {
    cursor: pointer !important;
    position: absolute;
    top:120px;
    left:3%;
  }

  .nextArrow {
    cursor: pointer !important;
    position: absolute;
    top:120px;
    left:94%;
  }

  #showForIE11 {
    display: none;
  }

  @media only screen and (max-width: 640px)  {

    .carousel {
      padding-right: 200px;
    }

    .carousel-controls {
      position: relative;
      top: 120px;
      pointer-events: none;
    }

    .slide {
      flex: 0 0 200px;
      height: 255px;
    }

    .slide-image {
      cursor: pointer;
      height: 250px;
      width: 177px;
      z-index: 999;
    }

    .slide {
      opacity: 1 !important;
    }


    .slide:nth-of-type(7n) {
      opacity: 1 !important;
    }


    .prevArrow {
      cursor: pointer;
      display: inline-flex;
      width: 32px;
      height: 32px;
    }

    .nextArrow {
      cursor: pointer;
      display: inline-flex;
      width: 32px;
      height: 32px;
      left: 89%;
    }

    h1 {
      font-size: 28px;
      line-height: 1.43;
      text-align: center;
      margin-top: 56px;
    }

    p {
      display: block;
      font-size: 14px;
      line-height: 1.71;
      text-align: center;
    }

    .research-cell {
      padding: 5px;
    }

  }

  @media only screen and (min-width: 641px)  {

    .carousel-controls {
      position: relative;
      top: 120px;
    }

    .slide {
      flex: 0 0 237px;
    }

    .slide:nth-of-type(3) {
      // opacity: 0.4 !important;
    }

    .slide:nth-of-type(9) {
      // opacity: 0.4 !important;
    }

    .slide-image {
      cursor: pointer;
      height: 290px;
      width: 206px;
    }

    .prevArrow {
      cursor: pointer;
      display: inline-flex;
      width: 48px;
      height: 48px;
    }

    .nextArrow {
      cursor: pointer;
      display: inline-flex;
      width: 48px;
      height: 48px;
    }

    h1 {
      font-size: 60px;
      line-height: 1.29;
      margin-top: 30px;
    }

    p {
      font-size: 21px;
      line-height: 1.52;
    }

    p strong {
      font-size: 24px;
      line-height: 1.5;
    }

    .research-cell {
      padding: 10px;
    }

  }

  @media screen and (-ms-high-contrast: active), screen and (-ms-high-contrast: none) {

    .full {
      padding-bottom: 96px !important;
    }
    #showForNonIE {
      display: none;
      height: 1px;
    }

    #showForIE11 {
      display: flex;
      margin: 40px 0 0 0;
    }

  }


</style>



// WEBPACK FOOTER //
// src/components/carousels/researchCarousel.vue